import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import FormSelect from "../../Components/FormTag/FormSelect";
import FormToggle from "../../Components/FormTag/FormToggle";
import InputFiled from "../../Components/FormTag/InputFiled";
import PageHeader from "../../Layout/PageHeader";
import {
  PHONE_USA
} from "../../Shared/Helper/Constant";
import { USA_PHONE_PATTERN_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import { defaultFormData, SupplierForm } from "./model/Supplier.type";
import toast, { Toaster } from "react-hot-toast";
import { formatPhoneNumber, getLocalStorageItem } from "../../Utility/Utility";
import { createSupplier, getSupplier, updateSupplier } from "./service/suppliers.service";
import { lookUpService } from "../../Services/common/lookup.service";
import { SelcetOption } from "../../model/common/apiResponse";
import Loader from "../../Components/GlobalLoader/Loader";
import useClientStore, { Client } from "../../store/client/useClientStore";

export default function SuppliersAddEdit() {
  const pageName = "Suppliers";
  const navigation = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const { id } = useParams(); 
  const [isEditMode, setIsEditMode] = useState(false);
  const [countryList, setCountryList] = useState<any>();
  const [loading, setLoading] = useState(true);
  const {getSelectedClient}= useClientStore();
   const [clientData, setClientData] = useState<Client | null>(null);
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<SupplierForm>({
    defaultValues: defaultFormData,
  });
  const [supplierCode, setsupplierCode] = useState<string>("");
  useEffect(() => {
    fetchCountryList().then(()=>{
      if (id) {
        setIsEditMode(true);
        fetchSupplierData(id).then(()=>{
            setLoading(false);
        }).catch((error) => {
          setLoading(true);
          navigation("/404")
        });
      }else{
        setLoading(false);
      }
    });
   
  }, [id]);
  useEffect(() => {
    const subscription = getSelectedClient().subscribe((client) => {
      setClientData(client);
    });

    return () => subscription.unsubscribe();
  }, [getSelectedClient]);
  const fetchCountryList = async () => {
    try {
      const countryData = await lookUpService.countryLookup();
      console.log(countryData?.data?.data);
    

      const countryList: SelcetOption[] =
      countryData.data?.data?.map((obj: any) => ({
          label: obj.name,
          value: obj.code,
        }));
        setCountryList(countryList);
    } catch (error) {

    }
  };
  const fetchSupplierData = async (id: string): Promise<void> => {
    try {
      const response = await getSupplier(id);
      if (response.data && response.status === 200) {
        response.data.country = response.data.country.code;
        reset(response.data); 
        setsupplierCode(response.data.code || "");
      } else {
        throw new Error("Failed to fetch supplier data");
      }
    } catch (error) {
      console.error("Failed to fetch supplier data:", error);
      throw error;
    }
  };
  const getClientData = async() => {
    if (clientData && Object.keys(clientData).length>0 && clientData.code!=='all') {
     return clientData;
    } else {
      toast.error("Client code is required!", { duration: 2000 });
      setSubmitting(false);
    }
  };

  const saveData: SubmitHandler<SupplierForm> = async (data) => {
    await getClientData();
    if (!clientData?.id || !clientData?.code || clientData.code==='all') {
      setSubmitting(false);
      return;
    }
    const formattedSupplierData = {
      ...data,  
      client: {
        code: clientData.code,
      },
    };
    if(data.country){
      formattedSupplierData.country={
        code: data.country,
      };
    }else{
      formattedSupplierData.country={};
    }
    try {
      let response;
      if (isEditMode && id) {
        response = await updateSupplier(id, formattedSupplierData);
      } else {
        response = await createSupplier(formattedSupplierData);
      }
      if (response.status === 201 || response.status === 200) {
        toast.success(`Supplier ${isEditMode ? "updated" : "created"} successfully!`, { duration: 2000 });
        reset(defaultFormData);
        setTimeout(() => {
          navigation("/account/client/supplier/grid-view");
        }, 1000)
        
      } else {
        toast.error(`An error occurred while ${isEditMode ? "updating" : "creating"} Supplier.`, {
          duration: 2000,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error(`An error occurred while ${isEditMode ? "updating" : "creating"} Supplier.`, {
        duration: 2000,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handelCancelBtn = () => {
    reset(defaultFormData); // Reset the form to default values
    navigation("/account/client/supplier/grid-view");
  };

  return !loading ?(
    <>
      <Toaster />
      <PageHeader
        addUrl="/account/client/supplier/add"
        listUrl="/account/client/supplier/list-view"
        gridUrl="/account/client/supplier/grid-view"
        name={pageName}
        viewType={true}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">
      {id ? `Edit Supplier (${supplierCode})` : "Create Supplier"}
      </h5>

      <div className="my-2 bg-white rounded p-3">
        
         <div className="d-flex px-2 gap-3">
            <div className="col-4 px-2">
            <label className="fw-medium">Supplier Code *</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="code"
                register={register}
                className="form-control"
                required={true}
                errors={errors?.code}
                placeholder="Enter Code"
              />
            </div>
            </div>
            <div className="col-4 px-2">
            <label className="fw-medium">Supplier Name *</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="name"
                register={register}
                className="form-control"
                required={true}
                errors={errors?.name}
                placeholder="Enter Name"
              />
            </div>
            </div>
            <div className="col-3 d-flex px-2 justify-content-center">
            <div className="ms-4">
              <label className="fw-medium">Active</label>
            </div>
            <div className="form-check form-switch sidebar-toggler">
              <div className="mx-2">
                <FormToggle
                  register={register}
                  name="is_active"
                />
              </div>
            </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
            <label className="fw-medium">Contact Name</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="contact_name"
                register={register}
                className="form-control"
                errors={errors?.contact_name}
                placeholder="Enter Contact Name"
              />
            </div>
             </div>
            <div className="col-4 px-2">
            <label className="fw-medium">Contact Telephone</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="contact_phone"
                register={register}
                className="form-control"
                errors={errors?.contact_phone}
                placeholder="000-000-0000"
                pattern={{
                  type: PHONE_USA,
                  message: USA_PHONE_PATTERN_ERR_MSG,
                }}
                onChange={async (e: any) => {
                  const formattedNumber = formatPhoneNumber(e.target.value);
                  setValue("contact_phone", formattedNumber);
                }}
              />
            </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
            <label className="fw-medium">Contact Email</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="contact_email"
                register={register}
                className="form-control"
                errors={errors?.contact_email}
                placeholder="Enter Contact Email"
              />
            </div>
             </div>
            <div className="col-4 px-2">
            <label className="fw-medium">Address 1</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="address_line_1"
                register={register}
                className="form-control"
                errors={errors?.address_line_1}
                placeholder="Enter Address 1"
              />
            </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
            <label className="fw-medium">Address 2</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="address_line_2"
                register={register}
                className="form-control"
                errors={errors?.address_line_2}
                placeholder="Enter Address 2"
              />
            </div>
             </div>
            <div className="col-4 px-2">
            <label className="fw-medium">Address 3</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="address_line_3"
                register={register}
                className="form-control"
                errors={errors?.address_line_3}
                placeholder="Enter Address 3"
              />
            </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
            <label className="fw-medium">Country</label>
            <div className="mt-1">
            <FormSelect
                    name="country"
                    autofocus={true}
                    tabIndex={7}
                    control={control}
                    optionList={countryList?? []}
                    // defaultValue={createAsnData.supplier}
                    // selectedOption={selectedSupplier}
                    className="form-control p-0 "
                    placeholder="Select"
                    isSearchable={true}
                  />
            </div>
             </div>
            <div className="col-4 px-2">
            <label className="fw-medium">State/Province</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="state_province"
                register={register}
                className="form-control"
                errors={errors?.state_province}
                placeholder="Enter State/Province"
              />
            </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
            <label className="fw-medium">City</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="city"
                register={register}
                className="form-control"
                errors={errors?.city}
                placeholder="Enter City"
              />
            </div>
             </div>
            <div className="col-4 px-2">
            <label className="fw-medium">Zip / Postal Code
            </label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="postal_code"
                register={register}
                className="form-control"
                maxLength={6}
                errors={errors?.postal_code}
                placeholder="Enter Zip / Postal Code"
              />
            </div>
            </div>
          </div>

      </div>

      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            className="sph-btn me-4"
            handleClick={handleSubmit(saveData)}
          >
             {isEditMode ? "Update" : "Submit"}
          </FormButton>
          <FormButton
            className="sph-btn sph-shift me-4"
            handleClick={handelCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  ):<Loader/>;
}